/**
 * QuantApe Assistant — the Chrome extension. Display constants only; the
 * listing itself is the source of truth. Every surface that links to the
 * store (footer, landing page, What's new) reads from here so the URL and the
 * one-line pitch can never drift between them.
 */

export const EXTENSION_URL =
  'https://chromewebstore.google.com/detail/quantape-assistant-stock/ljlmidkjkhdpembngjggadcodlaifeai';

export const EXTENSION_NAME = 'QuantApe Assistant';

// Mirrors chrome-extension/manifest.json `description`.
export const EXTENSION_PITCH =
  'Spot stock tickers on any page. Click to see fundamentals, momentum, ratings, earnings, and risk factors.';
